import { testimonials } from "@/mocks/guaData";

function Stars({ n }: { n: number }) {
  return (
    <div className="flex gap-0.5 text-accent-500">
      {Array.from({ length: 5 }).map((_, i) => (
        <i key={i} className={`${i < n ? "ri-star-fill" : "ri-star-line"} text-sm`}></i>
      ))}
    </div>
  );
}

export default function Reviews() {
  return (
    <section id="reviews" className="px-4 md:px-8 py-12 md:py-16 bg-background-100/70">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-6 items-center">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-1.5 text-primary-600 font-medium text-sm">
              <i className="ri-heart-3-fill"></i> 频道口碑 · 编辑部的话
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-2 leading-tight">
              追瓜不迷路，
              <br />
              我们是你的吃瓜搭子
            </h2>
            <p className="text-foreground-500 text-sm md:text-[15px] leading-relaxed mt-4">
              吃瓜频道坚持「讲事实、看门道、不跟风」，用清晰的栏目索引与客观的内容盘点，陪你把每一次热点都追得明明白白。
              这里不谈立场只摆事实，给瓜友们一个轻松、热闹又靠谱的信息港湾。
            </p>
            <div className="mt-6 flex items-center gap-6">
              <div>
                <p className="font-heading text-3xl font-bold text-primary-600">4.9/5</p>
                <p className="text-xs text-foreground-500 mt-1">用户满意度</p>
              </div>
              <div>
                <p className="font-heading text-3xl font-bold text-primary-600">500万+</p>
                <p className="text-xs text-foreground-500 mt-1">活跃瓜友</p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-8 grid sm:grid-cols-2 gap-4 md:gap-5">
            {testimonials.map((t) => (
              <figure key={t.id} className="bg-background-50 border border-background-200 rounded-2xl p-5 md:p-6">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <span className="w-10 h-10 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center font-heading font-bold text-base">
                      {t.name.charAt(0)}
                    </span>
                    <div>
                      <figcaption className="font-medium text-foreground-950 text-sm">{t.name}</figcaption>
                      <p className="text-xs text-foreground-400">{t.role}</p>
                    </div>
                  </div>
                  <Stars n={t.stars} />
                </div>
                <blockquote className="text-foreground-600 text-sm leading-relaxed mt-4">“{t.text}”</blockquote>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}